import React from 'react';
import { motion } from 'framer-motion';
import {Link, useNavigate} from 'react-router-dom';
import { FaIndustry, FaUsers, FaProjectDiagram, FaGlobeAfrica } from 'react-icons/fa';
import './AboutContent.css';
import {useTranslation} from "react-i18next";

interface Feature {
  icon: React.ReactNode;
  title: string;
  text: string;
}

const AboutContent: React.FC = () => {
    const navigate = useNavigate();
  const { t } = useTranslation();

  // Features data
  var features: Feature[] = [
    {
      icon: <FaIndustry />,
      title: t('home.about.features.feature1', 'Expertise Industrielle'),
      text: t('home.about.features.feature1-desc', 'Plus de 25 ans d\'expérience dans le secteur industriel')
    },
    {
      icon: <FaUsers />,
      title: t('home.about.features.feature2', 'Équipe Qualifiée'),
      text: t('home.about.features.feature2-desc', 'Professionnels hautement qualifiés et expérimentés')
    },
    {
      icon: <FaProjectDiagram />,
      title: t('home.about.features.feature3', 'Solutions Personnalisées'),
      text: t('home.about.features.feature3-desc', 'Approche sur mesure adaptée à vos besoins spécifiques')
    },
    {
      icon: <FaGlobeAfrica />,
      title: t('home.about.features.feature4', 'Présence Nationale'),
      text: t('home.about.features.feature4-desc', 'Services disponibles dans tout le Maroc')
    }
  ];


  const handleLinkClick = (path: string) => {
        window.scrollTo(0, 0);
        navigate(path);
    };

    return (
    <div className="about-content">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        viewport={{ once: true }}
      >
        <div className="about-subtitle">
          {t('home.about.title', 'À Propos de Nous')}
        </div>
        <h2 className="about-title">
          {t('home.about.subtitle', 'Votre Partenaire de Confiance pour les Solutions Industrielles')}
          </h2>
      </motion.div>
      
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.2 }}
        viewport={{ once: true }}
      >
        <p className="about-description">
          {t('home.about.description', 'Africa Supply Service SARL est une entreprise marocaine fondée en 2021, spécialisée dans la fourniture de solutions techniques et industrielles sur mesure. Notre force réside dans une équipe hautement qualifiée cumulant plus de 23 ans d’expérience dans les secteurs de l\'industrie, de l\'eau, de l\'énergie et de la maintenance technique.')}
        </p>
        <p className="about-description">
          {t('home.about.mission', 'Notre mission est de fournir des services industriels de haute qualité, adaptés aux besoins de nos clients, avec professionnalisme, réactivité et efficacité, tout en respectant les normes les plus strictes en matière de sécurité et de durabilité.')}
        </p>
      </motion.div>
      
      <div className="feature-grid">
        {features.map((feature, index) => (
          <motion.div
            key={index}
            className="feature-item"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.3 + (index * 0.1) }}
            viewport={{ once: true }}
          >
            <div className="feature-icon">{feature.icon}</div>
            <h3 className="feature-title">{feature.title}</h3>
          </motion.div>
        ))}
      </div>
      
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, delay: 0.7 }}
        viewport={{ once: true }}
      >
        <Link to="/about" className="about-button"
              onClick={() => handleLinkClick('/about')}
        >
          {t('common.learnMore', 'En savoir plus')}

        </Link>
      </motion.div>
    </div>
  );
};

export default AboutContent;
